// extracted by mini-css-extract-plugin
export default {"container":"_70Wt8","title":"Xg7V2O","button":"FMMnZn"};